import { navigateTo } from "../../../../../navigationService/navigationServiceFunctions"

function getFeatureWithRoadId(features) {
    return features.find(f => f.properties?.RoadID != null)
}

export function handleFeatureRoadApproximation(features: any) {
    const featureWithRoadId = getFeatureWithRoadId(features)
    const roadId = featureWithRoadId?.properties?.RoadID
    if (roadId) {
        navigateTo(`/app/road/${roadId}`)
    }
}